import { Component } from '@angular/core';

@Component({
  selector: 'mprd-internet-settings-skeleton',
  templateUrl: './internet-settings-skeleton.component.html',
})
export class InternetSettingsSkeletonComponent {
  constructor() {}
}
